module.exports = __webpack_public_path__ + "static/img/3.18b48935.jpg";